import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { path, pathOr } from 'ramda';
import { connect } from 'react-redux';

import { openModalPerson, openModalProject, openModalCompany } from 'actions/modalActions';
import { DefinitionField } from 'components/common/fields/DefinitionField';
import { getDateTimeRange } from 'helpers/fieldsHelpers';

const getItem = (type, item) => pathOr({ id: false }, [type, 0], item);

@connect(null, { openModalPerson, openModalProject, openModalCompany })
export default class EventView extends Component {
    static propTypes = {
        item: PropTypes.object,
        view: PropTypes.object,
        openModalPerson: PropTypes.func,
        openModalProject: PropTypes.func,
        openModalCompany: PropTypes.func,
    };

    renderParticipants = () => {
        const { openModalPerson, item: { details: { participants } } } = this.props;

        return participants ? (
            <ul>
                { participants.map(({ id, text }) => (
                    <li key={id}>
                        <a onClick={() => openModalPerson({
                            id,
                            value: text,
                        })}>
                            {text}
                        </a>
                    </li>
                ))}
            </ul>
        ) : null;
    }

    render() {
        const { openModalPerson, openModalProject, openModalCompany } = this.props;
        const { item: { comment, details, view = {} } } = this.props;
        const { orgstr, soispstr } = view;

        const date = path(['eventDate'], details);
        const time = path(['eventTime'], details);

        const responsible = getItem('responsible', details);
        const schedule = getItem('schedule', details);
        const person = getItem('people', details);
        const company = getItem('company', details);
        const project = getItem('project', details);
        const contact = getItem('contact', details);

        return (
            <div className="panel-view">
                <DefinitionField translate='events.date' text={date} />
                <DefinitionField translate='events.time' text={getDateTimeRange(time)} />
                <DefinitionField translate='events.responsible' show={responsible.id}>
                    <a onClick={() => openModalPerson({
                        id: responsible.id,
                        value: responsible.text,
                    })}>
                        {responsible.text}
                    </a>
                </DefinitionField>
                <DefinitionField translate='events.participants' show={true}>
                    {this.renderParticipants()}
                </DefinitionField>
                <DefinitionField translate='events.schedule' show={schedule.id}>
                    <a onClick={() => openModalPerson({
                        id: schedule.id,
                        value: schedule.text,
                    })}>
                        {schedule.text}
                    </a>
                </DefinitionField>
                <DefinitionField translate='events.project' show={project.id}>
                    <a onClick={() => openModalProject(project)}>
                        {project.text}
                    </a>
                </DefinitionField>
                <DefinitionField translate='events.person' show={person.id}>
                    <a onClick={() => openModalPerson({
                        id: person.id,
                        value: person.text,
                    })}>
                        {person.text}
                    </a>
                </DefinitionField>
                <DefinitionField translate={orgstr || 'events.company'} show={company.id}>
                    <a onClick={() => openModalCompany(company)}>
                        {company.text}
                    </a>
                </DefinitionField>
                <DefinitionField translate={soispstr || 'events.contact'} show={contact.id}>
                    <a onClick={() => openModalPerson({
                        id: contact.id,
                        value: contact.text,
                    })}>
                        {contact.text}
                    </a>
                </DefinitionField>
                <DefinitionField textClassName="newline text-justify text-pre-space" translate='events.comment' text={comment} />
            </div>
        );
    }
}
